import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  mode: "history",
  routes: [
    {
      path: "/ggyvy", // 隐私协议
      name: "Ggyvy",
      meta: {
        title: "Perjanjian privasi",
      },
      component: () => import("@/views/ggyvy/index.vue"),
    },
    {
      path: "/phyr", // 关于我们
      name: "Phyr",
      meta: {
        title: "Tentang kami",
      },
      component: () => import("@/views/phyr/index.vue"),
    },
    {
      path: "/yivcxn", // 投诉
      name: "Yivcxn",
      meta: {
        title: "Komplain",
      },
      component: () => import("@/views/yivcxn/index.vue"),
    },
    {
      path: "/vbfdsfd", // 投诉
      name: "vbfdsfd",
      component: () => import("@/views/vbfdsfd/index.vue"),
    },
  ],
});

export default router;
